import React from "react";
import { Col, Form } from "react-bootstrap";
import { filter, map, noop } from "lodash";

import Button from "components/Button";

interface Group {
  id: string;
  name: string;
}

interface GroupSelectionProps {
  goToNamedStep?: (step: string) => void;
  push?: (...args: unknown[]) => void;
  setSourceGroupId?: (value: string) => void;
  setTargetGroupId?: (value: string) => void;
  isFetching?: boolean;
  client?: Record<string, unknown>;
  // groups is keyed by group id; iterated via lodash map yielding { id, name }
  groups: Record<string, Group>;
  sourceGroupId?: string;
  targetGroupId?: string;
  onCancel?: () => void;
  // identifier read by the react-step-wizard parent (StepWizard)
  stepName?: string;
}

class GroupSelection extends React.PureComponent<GroupSelectionProps> {
  _getGroupsForSelect = () => {
    return map(this.props.groups, (group) => {
      return {
        value: group.id,
        label: group.name,
      };
    });
  };

  render() {
    const sourceGroupList = this._getGroupsForSelect();
    const targetGroupList = filter(sourceGroupList, (group) => {
      return group.value !== this.props.sourceGroupId;
    });

    return (
      <div>
        <div className="workflow-widget">
          <Form noValidate onSubmit={noop}>
            <Form.Group md={6} controlId="sourceGroup" as={Col}>
              <Form.Label>Source Group (Group migrating from)</Form.Label>
              <Form.Select
                name="sourceGroupId"
                value={this.props.sourceGroupId}
                onChange={(e) =>
                  // optional per propTypes but invoked unconditionally (as in
                  // the original JS); assert non-null to preserve that
                  this.props.setSourceGroupId!(e.target.value)
                }
              >
                <option value="" disabled>
                  Select Source Group
                </option>
                {map(sourceGroupList, (opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            {this.props.sourceGroupId && (
              <Form.Group md={6} controlId="targetGroup" as={Col}>
                <Form.Label>Target Group (Group migrating to)</Form.Label>
                <Form.Select
                  name="targetGroupId"
                  value={this.props.targetGroupId}
                  onChange={(e) =>
                    // optional per propTypes but invoked unconditionally (as in
                    // the original JS); assert non-null to preserve that
                    this.props.setTargetGroupId!(e.target.value)
                  }
                >
                  <option value="" disabled>
                    Select Target Group
                  </option>
                  {map(targetGroupList, (opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            )}
          </Form>
        </div>
        <div className="process-payroll-button-row">
          <Button
            // onCancel optional per propTypes but invoked unconditionally
            // (as in the original JS); assert non-null to preserve that
            onClick={() => this.props.onCancel!()}
            btnLabel="Cancel"
            name="cancel"
            color="cancel"
          />
          <Button
            name="action"
            disabled={!this.props.targetGroupId || !this.props.sourceGroupId}
            // goToNamedStep optional per propTypes but invoked unconditionally
            // (as in the original JS); assert non-null to preserve that
            onClick={() => this.props.goToNamedStep!("employeeSelection")}
          />
        </div>
      </div>
    );
  }
}

export default GroupSelection;
